import type { FieldValues } from "react-hook-form";
import { useIsRowHidden } from "src/components/Form/hooks/useIsRowHidden.ts";
import { Flex } from "src/components/Flex.tsx";
import { FieldRowField } from "src/components/Form/panels/DefaultFormPanel/FieldRowField.tsx";
import React from "react";
import { mapObjectToArray } from "@exonn/utils";
import type { ValidArrayField } from "src/components/Form/Form.types.ts";

export const FieldRow = <FormValues extends FieldValues = FieldValues>({
  fields,
}: {
  fields: readonly ValidArrayField<FormValues>[];
}) => {
  const { isHidden } = useIsRowHidden({
    names: fields.filter((name) => !!name),
  });

  const visibleFields = fields.filter((name) => {
    return !isHidden[name] || name === "";
  });
  const hiddenFields = fields.filter((name) => {
    return isHidden[name];
  });
  if (mapObjectToArray(isHidden, (value) => value).every(Boolean)) {
    return null;
  }
  // hidden fields should be at the end. so that there is no empty space in the beginning of the row
  const reorderedFields = [...visibleFields, ...hiddenFields];
  return (
    <Flex gap={10}>
      {reorderedFields.map((name, index) => {
        const key =
          name === "" ? "__placeholder__" + index : JSON.stringify(name);
        return <FieldRowField key={key} name={name} />;
      })}
    </Flex>
  );
};
